<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive==='false' || isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li class="active" (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>       
        
        </div>
    </div>
    <div class="w85">
        <div class="p-3">
            <label class="bold fs-18 txt-black1">Forms</label>
            <div class="regular fs-16"><a class="underline cp" (click)="refundBoxFile()">Refund Request Form</a></div>
            <div class="clear10"></div>
            <div class="regular fs-16"><a class="underline cp" (click)="applicationExtensionForm()">Application for Extension Form</a></div>
            <div class="clear10"></div>
            <div class="regular fs-16"><a class="underline cp" (click)="getClaimForm()">ISP Claim Form</a></div>
            <div class="clear20"></div>
            <label class="bold fs-18 txt-black1">Policy Wording</label>
            <div class="regular fs-16"><a (click)="policyWording()" class="underline cp">International Student Travel Insurance Policy (ISP)</a></div>
        </div>
    </div>
</div>
<div id="viewPolicyDetails1" class="modal" [style.display]="viewPolicyDetailsPopup1 ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 text-right">
                    <h6 class="close" (click)="viewPolicyDetailsPopup1=!viewPolicyDetailsPopup1">&times;</h6>
                    <div class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                </div>
            </div>
            <div class="clear10"></div>
            <iframe [src]='UrlBoxPolicy | sanitizePipe' height="500px" width="100%" title="Policy Wording"></iframe>
        </div>
    </div>
  </div>